import "./App.css";
import "./scorecardtheme.css";
import WalletPage from "./components/WalletComponents/WalletPage";
import DefaultPage from "./components/DefaultPage";
import SportsPage from "./components/SportsPage";
import WalletInfo from "./components/WalletComponents/WalletInfo";
import Footer from "./components/WalletComponents/Footer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NoAccessPage from "./components/no-access";
import IframePage from "./components/pages/IframePage";
import ProfilePage from "./components/WalletComponents/ProfilePage";
import TransactionHistory from "./components/WalletComponents/TransactionHistory/TransactionHistory";
import TransactionHistoryDetails from "./components/WalletComponents/TransactionHistory/TransactionHistoryDetails";
import CasinoIframe from "./components/pages/CasinoIframe";
import Site from "./components/pages/Site";
import HomePage from "./components/Home/Home";
import PlayGame from "./components/pages/PlayGame";
import BannerInfo from "./components/BannerInfo/BannerInfo";
import ProviderGames from "./components/ProviderGames/ProviderGames";
import { useEffect, useState } from "react";
import Loader from "../src/assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { Backdrop } from "@mui/material";
import MyProfile from "./components/WalletComponents/MyProfile/MyProfile";
import "./theme/variables.css"
import CustomerSupport from "./components/pages/CustomerSupport/CustomerSupport";
import TicketDetails from "./components/pages/CustomerSupport/TicketDetails";
import BetList from "./components/pages/BetList/BetList";
import AccountStatement from "./components/pages/AccountStatement/AccountStatement";
import FAQ from "./components/pages/FAQ/FAQ";
import NewTicket from "./components/pages/CustomerSupport/NewTicket";
import BetDetails from "./components/pages/BetList/BetDetails";
import EventsPage from "./components/EventsPage/EventsPage";
import ExchangeMarketsPage from "./components/ExchangeMarketsPage/ExchangeMarketsPage";
import WagerList from "./components/pages/WagerList/WagerList";
import PrivacyPolicy from "./components/pages/PrivacyPolicy/PrivacyPolicy";
import SportsBookMarketPage from "./components/SportsBookMarketPage/SportsBookMarketPage";
import { getRefId, getUserBalance } from "./store/authActions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./store/store";
import { useAuth } from "./hooks/hook";
import Logout from "./components/Logout";
import SeeAll from "./components/SeeAll/SeeAll";
import LoginPage from "./components/Login";
import { setBrowser, setIsLoggedIn } from "./store/authReducer";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import LoginWrapper from "./components/LoginWrapper";

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  start_param?: string;
}

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DefaultPage />} />
      <Route path="wallet" element={<WalletPage />} />
      <Route path="sports" element={<SportsPage />} />
      <Route path="casino" element={<CasinoIframe />} />
      <Route path="site" element={<Site />} />
      <Route path="iframe" element={<IframePage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="transactions" element={<TransactionHistory />} />
      <Route path="home" element={<HomePage />} />
      <Route path="play/:gameInfo" element={<PlayGame />} />
      <Route path="bannerinfo" element={<BannerInfo />} />
      <Route path="providergames" element={<ProviderGames />} />
      <Route path="myprofile" element={<MyProfile />} />
      <Route path="customersupport" element={<CustomerSupport />} />
      <Route path="/ticket-details" element={<TicketDetails />} />
      <Route path="/betlist" element={<BetList />} />
      <Route path="/account-statement" element={<AccountStatement />} />
      <Route path="/transaction-history-details" element={<TransactionHistoryDetails />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/new-ticket" element={<NewTicket />} />
      <Route path="/bet-details" element={<BetDetails />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/events/:gameInfo" element={<EventsPage />} />
      <Route path="/markets/:gameInfo" element={<ExchangeMarketsPage />} />
      <Route path="/sb-markets/:gameInfo" element={<SportsBookMarketPage />} />
      <Route path="/wager-list" element={<WagerList />} />
      <Route path="/see-all" element={<SeeAll />} />
      <Route path="/*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

const ConditionalRoutes = () => {
  const location = useLocation();
  const path = location.pathname;
  const dispatch = useDispatch<AppDispatch>();
  const key = new URLSearchParams(window.location.search).get("id");
  const [user, setUser] = useState<any>();
  const navigate = useNavigate();
  const [blockPopupOpen, setBlockPopupOpen] = useState(false);
  const { isBlocked } = useAuth();

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!path.startsWith("/markets") && !path.startsWith("/sb-markets")) return;
    const intervalId = setInterval(() => {
      dispatch(getUserBalance());
    }, 10000);

    return () => clearInterval(intervalId);
  }, [path]);

  const decodeBase64 = (base64: string) => {
    try {
      const decodedString = atob(base64); // Decode Base64
      return JSON.parse(decodedString); // Convert to JSON
    } catch (error) {
      console.error("Error decoding Base64:", error);
      return null;
    }
  };

  useEffect(() => {
    const tg = (window as any)?.Telegram?.WebApp;
    tg?.ready();
    const initData = (window as any)?.Telegram?.WebView?.initParams
      ?.tgWebAppData;


    const userData: TelegramUser = tg?.initDataUnsafe?.user;
    if (userData) {
      setUser(userData);
    }

    const userId = userData?.id;
    if (key && userId) {
      const existingKey = sessionStorage.getItem("userKey");
      const newKey = `${key}-${userId}`;

      if ((existingKey !== newKey) && (newKey?.split("-")?.length > 1)) {
        // sessionStorage.setItem("userKey", newKey || "");
      } else {
      }
    } else {
      // navigate("/no-access");
    }

    dispatch(getRefId());

    if (initData) {
      const urlParams = new URLSearchParams(initData);
      const startParam = urlParams.get("start_param");
      // if (path.startsWith("/wallet") && startParam) {
      //   const jsonData = decodeBase64(startParam);

      //   if (jsonData) {
      //     const { transaction_id, amount, currency } = jsonData;
      //     navigate("/wallet", { state: { tId: transaction_id, amount: amount, curType: currency?.type, curCategory: currency?.category } });
      //   }
      // }

      if (startParam) {
        const jsonData = decodeBase64(startParam);

        if (jsonData && jsonData.page) {
          const { page, ...rest } = jsonData;

          switch (page.toLowerCase()) {
            case "event":
              if (rest.id && rest.name && rest.lobby) {
                navigate(`/events/${btoa(`${rest.id}#${rest.name}#${rest.lobby}`)}`);
              }
              break;

            case "market":
              if (rest.id && rest.lobby) {
                const marketPath = rest.lobby.toUpperCase() === "SPORTSBOOK"
                  ? `/sb-markets/${btoa(`${rest.id}`)}`
                  : `/markets/${btoa(`${rest.id}`)}`;
                sessionStorage.setItem("previousPath", "/sports");
                navigate(marketPath);
              }
              break;

            case "customersupport":
              navigate(`/customersupport`)
              break;
            case "bonus":
              navigate("/wallet", { state: { tId: rest?.transaction_id, amount: rest?.amount, curType: rest?.currency?.type, curCategory: "" } });
              break;
            case "ticket-details":
              navigate("/ticket-details", { state: { ticketId: rest?.ticketId } });
              break;
            case "playgame":
              navigate(`/play/${btoa(`${rest?.id}:${rest?.id}:${rest?.tgProviderId}:${rest?.provider}:${rest?.subProvider}:${rest?.type}:${rest?.category}:${rest?.tableId ? rest?.tableId : ""}:${false}:${false}`)}`)
              break;
            case "home":
              navigate(`/home`)
              break;
            case "casino":
              navigate(`/casino`)
              break;
            case "sports":
              navigate(`/sports`)
              break;
            case "site":
              navigate(`/site`)
              break;
            case "wallet":
              navigate(`/wallet`)
              break;
            case "providergames":
              const prov = {
                provider: rest?.provider,
                subProvider: rest?.subProvider,
                tgProviderId: rest?.tgProviderId,
                thumbnail: rest?.thumbnail,
              }
              sessionStorage.setItem("previousPath", "/casino");
              navigate("/providergames", { state: { prov } });
              break;
            case "profilepage":
              sessionStorage.setItem("previousPath", "/profile");
              if (rest?.profileOption) {
                switch (rest?.profileOption) {
                  case "myprofile":
                    navigate(`/myprofile`)
                    break;
                  case "transactions":
                    navigate(`/transactions`)
                    break;
                  case "accountstatement":
                    navigate(`/account-statement`)
                    break;
                  case "faq":
                    navigate(`/faq`)
                    break;
                  case "betlist":
                    navigate(`/betlist`)
                    break;
                }
              }
              break;
            default:
              console.warn("Unknown page type or missing required fields:", jsonData);
          }
        }
      }
    }

  }, []);
  useEffect(() => {
    if (isBlocked || sessionStorage.getItem("user_blocked") === "true") {
      const timer = setTimeout(() => {
        setBlockPopupOpen(true);
      },1200);
      return () => clearTimeout(timer);
    }
  }, [isBlocked]);


  const pathsToShow = ["/casino", "/wallet", "/sports", "/site", "/iframe", "/myprofile", "/profile", "/transactions", "/home", "/play", "/bannerinfo", "/providergames", "/betlist", "/account-statement", "/customersupport", "/ticket-details", "/transaction-history-details", "/new-ticket", "/events", "/bet-details", "/wager-list", "/faq", "/privacypolicy", "/markets",
    "/sb-markets", "/see-all", "/login"
  ];
  return (
    <>

      <Backdrop
        sx={{ color: "#051314", zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <div className="fullWidth">
          <img className="" src={Loader} alt="" />
        </div>
      </Backdrop>
      {
        !loading && (
          <>
            {path.startsWith("/play") || path.startsWith("/markets") || path.startsWith("/sb-markets") ? (
              <AppRoutes />
            ) : pathsToShow.some((validPath) => path.startsWith(validPath)) ? (
              <>
                <WalletInfo balance="0.230089" />
                <AppRoutes />
                <Footer />
              </>
            ) : (
              <NoAccessPage />
            )}
          </>
        )
      }
      {blockPopupOpen && (
        <Dialog
          fullScreen={false}
          open={blockPopupOpen}
          onClose={() => {
            sessionStorage.removeItem("user_blocked");
            setBlockPopupOpen(false);
          }}
          PaperProps={{
            style: {
              position: 'absolute',
              top: '5rem',
            },
          }}
        >
          <div className="dialog-bg bg-inputbox-color relative p-4 min-w-[20rem]">
            <CloseIcon
              className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
              onClick={() => {
                sessionStorage.removeItem("user_blocked");
                setBlockPopupOpen(false);
              }}
            />
            <div className="text-white">
              <h2 className="text-lg font-semibold mb-2">🚫 User Blocked</h2>
              <p className="text-sm text-zinc-400 mb-4">
                User Blocked. Please contact support.
              </p>
              <div className="flex justify-between">
                <button
                  type="button"
                  className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                  onClick={() => {
                    sessionStorage.removeItem("user_blocked");
                    setBlockPopupOpen(false);
                  }}
                >
                  OK
                </button>
                <button
                  type="button"
                  className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                  onClick={() => {
                    sessionStorage.removeItem("user_blocked");
                    setBlockPopupOpen(false);
                    navigate("/customersupport");
                  }}
                >
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

function App() {

  const key = new URLSearchParams(window.location.search).get("id");
  const { initializeAuth } = useAuth();
  const [appState, setAppState] = useState({
    isLoading: true,
    isTelegramBrowser: true,
    tgInitData: null as any,
  });
  const dispatch = useDispatch();
  const [userKey, setUserKey] = useState<any>("");
  const userDetails = useSelector((state: RootState) => state.userDetails);
  const [isToken, setIsToken] = useState<any>({
    isAuth: true,
    token: "",
  });
  const [isTele, setIsTele] = useState<any>("");
  const [referal, setReferal] = useState<any>("");

  const authenticateUser = async (initdata: any, key: any): Promise<{ success: boolean }> => {
    const { success, token } = await initializeAuth(initdata, key);

    setAppState((prev) => ({
      ...prev,
      isLoading: !success,
    }));
    return { success: success }
  };


  useEffect(() => {
    (async () => {
      const fetchData = async (): Promise<{ success: boolean }> => {
        try {
          const tg = (window as any)?.Telegram?.WebApp;
          tg?.ready();

          const isTG = !!tg?.initDataUnsafe?.user;
          if (isTG) {
            dispatch(setBrowser("TG"));
            let Ukey = "";
            const userData: TelegramUser = tg?.initDataUnsafe?.user;
            const userId = userData?.id;

            if (key && userId) {
              const newKey = `${key}-${userId}`;
              Ukey = newKey;
              setUserKey(newKey);
              sessionStorage.setItem("userKey", newKey || "");
            }

            const initData = (window as any)?.Telegram?.WebView?.initParams?.tgWebAppData;

            const { success } = await authenticateUser(
              initData,
              Ukey
            );

            if (initData) {
              setAppState((prev) => ({
                ...prev,
                tgInitData: initData,
              }));
            } else {
              setAppState((prev) => ({
                ...prev,
                isTelegramBrowser: false,
                isLoading: false,
              }));
            }
            return { success: success }
          }
        } catch (error) {
          console.log("Error while fetching the init data", error);
          setAppState((prev) => ({
            ...prev,
            isTelegramBrowser: false,
            isLoading: false,
          }));
        }

        return { success: false }
      };

      const { success } = await fetchData();

      if (success) {
        dispatch(setIsLoggedIn(true))
      }
    })();
  }, []);

  useEffect(() => {
    const tg = (window as any)?.Telegram?.WebApp;
    tg?.ready();

    const isTG = !!tg?.initDataUnsafe?.user;
    if (isTG) {
      setIsTele("TG");
      dispatch(setBrowser("TG"));
    } else {
      const searchParams = new URLSearchParams(window.location.search);
      const referral = searchParams.get("referral");
      if (referral) {
        setReferal(referral);
      }
      setIsTele("Web")
    }

    // setIsTele("TG");
  }, [])

  useEffect(() => {
    if (isTele !== 'TG') {
      // Restore isLoggedIn from sessionStorage
      const storedIsLoggedIn = sessionStorage.getItem("isLoggedIn");
      if (storedIsLoggedIn === "true") {
        dispatch(setIsLoggedIn(true));
      }
    }
  }, [dispatch, isTele]);

  useEffect(() => {
    if (isTele !== 'TG') {
      // Persist isLoggedIn to sessionStorage
      if (userDetails && userDetails.isLoggedIn) {
        sessionStorage.setItem("isLoggedIn", "true");
      } else {
        sessionStorage.setItem("isLoggedIn", "false");
      }
    }
  }, [userDetails, isTele]);

  return (
    <Router>
      <div className="flex flex-col mx-auto w-full bg-custom-bg bg-repeat bg-auto bg-cover min-h-screen gradient-div">
        <div className="flex flex-col w-full">

          {isTele === '' ? (
            <div className="home-loading">
              <img src={Loader} style={{ height: '10rem' }} />
            </div>
          ) : userDetails.logout ? (
            isTele === 'Web' ? (
              <Routes>
                <Route path="/login" element={<LoginWrapper referalCode={referal} />} />
                <Route path="/*" element={<Navigate to="/login" replace />} />
              </Routes>
            ) : (
              <Logout />
            )
          ) : userDetails.isLoggedIn ? (
            <ConditionalRoutes />
          ) : isTele === 'TG' ? (
            <div className="home-loading">
              <img src={Loader} style={{ height: '10rem' }} />
            </div>
          ) : (
            <Routes>
              <Route path="/login" element={<LoginWrapper referalCode={referal} />} />
              <Route path="/*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}

        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Router>
  );
}

export default App;
